import React from "react";
import { CategoryDetail, FormSectionElements, FunctionDetail, ProgramContainer } from "../../../entities/formTemplateDataType";
import { Heading1 } from "../../../theme";
import { ErrorAlertComponent } from "../../odsCalloutBox/ErrorAlertComponent";
import CMAUtils from "../../../utilities/CMAUtils";

interface Props {
    programContainer: ProgramContainer
    callbackStepIndex?: (index: number, returnIndex?:number) => void;
    callback:(programContainer: ProgramContainer)=>void;
    callbackValueSaved
}

interface State {
    showError: boolean;
    boxChecked: boolean;
}

export class CMAReviewComponent extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            showError: false,
            boxChecked: false,
        }
    }
    reviewPageIndex = 3;
    functionContent = (f: FunctionDetail, index: number, sectionIndex: number) => {
        let htmlString = [];
        let categoryHtml = [];
        console.log(f.CategoryDetailList)
        f.CategoryDetailList.forEach((c, index) =>{
            categoryHtml.push(this.categoryContent(c, index, sectionIndex));
            sectionIndex = sectionIndex + 1;
        });
        htmlString.push(
            <div className="ontario-summary-list">
                <div className="ontario-summary-list-heading__container">
                    <h3 className="ontario-summary-list__heading">{"Summary function " + String(index+1) + ": "} {f.FunctionName}</h3>
                </div>
                <dl className="ontario-summary-list__container">
                    {categoryHtml}
                </dl>
            </div>
        );
        return htmlString;
    }

    calculateCategoryScore = (sectionIndex: number) => {
        const section = this.props.programContainer.ListOfFormSections[sectionIndex];
        const eleList = section.ListOfFormSubSections[0].ListOfFormSectionElements;
        const score = eleList.reduce((acc, ele) => acc + ele.Value?.level, 0.0) / eleList.length;
        return (Math.trunc(score*10)/10);
    }

    categoryContent = (c: CategoryDetail, index: number, sectionIndex: number) => {
        return(
            <div className="ontario-summary-list__row">
                <dt className="ontario-summary-list__key">
                    {"Category " + String(index+1) + ": " + c.CategoryName}
                </dt>
                <dd className="ontario-summary-list__value">
                    {this.checkStatus(sectionIndex+1)}
                </dd>
                <dd className="ontario-summary-list__value">
                    score: {this.calculateCategoryScore(sectionIndex+1)}
                </dd>
                <dd className="ontario-summary-list-button__container">
                    <a className="ontario-summary-list-change__button" 
                     onClick={() => this.props.callbackStepIndex(sectionIndex+1)}>
                        Change
                    </a>
                </dd>
            </div>
        );
    }
    checkStatus = (sectionIndex: number) => {
console.log(this.props.programContainer);
        const eleList = this.props.programContainer.ListOfFormSections[sectionIndex].ListOfFormSubSections[0].ListOfFormSectionElements;
        let completionCount = 0;
        eleList.forEach((ele) => {
            if (ele.Value) completionCount = completionCount + 1;
        })
        if (completionCount == 0) {
            return "Not started yet"; 
        }
        else if (completionCount == eleList.length){
            return "Completed"; 
        }
        else {
            return "In progress"; 
        }
    }

    render() {
        const p = this.props.programContainer;
        const functions = p.CMATemplateList.filter(cma=>cma.Name==p.Template)[0]?.Functions;
        let htmlString = [];
        let sectionIndex = this.reviewPageIndex + 1;
        htmlString.push(
            <ErrorAlertComponent 
                bodyMsg={"You must accept the collection and use of information to continue."} 
                title={"Please accept the Legal Disclaimer to proceed further"} 
                isEng={true} 
                Visible={this.state.showError}/>
        );

        htmlString.push(<Heading1>Review your answers</Heading1>);

        functions.forEach((f, index) => {
            htmlString.push(this.functionContent(f, index, sectionIndex));
            sectionIndex = sectionIndex + f.CategoryDetailList.length;
        })

        // declaration
        htmlString.push(
            <p>I solemnly declare that the information made in this application is true and understand that any false statements will be forwarded to the relevant law enforcement authority for investigation of an offence under the Criminal Code and the Highway Traffic Act, and could result in the cancellation of my permit, a fine and/or imprisonment. Under the Highway Traffic Act, it is an offence to fraudulently obtain an Accessible Parking Permit and any person who contravenes the Act may be liable for a fine of up to $5,000. I authorize the release of health information for the completion of this form to ServiceOntario.</p>
        );

        // checkbox
        
        htmlString.push(
            <div className="ontario-form-group">
                <fieldset className="ontario-fieldset">
                    <legend className="ontario-fieldset__legend">
                        Confirmation<span className="ontario-label__flag">(required)</span>
                    </legend>
                    {this.state.showError && !this.state.boxChecked && <div className="ontario-error-messaging" role="alert">
                        <span className="ontario-error-messaging__icon">
                            <svg className="ontario-icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                                <use href="#ontario-icon-alert-error"></use>
                            </svg>
                        </span>
                        <span className="ontario-error-messaging__content">
                            You must accept the collection and use of information to continue.
                        </span>
                    </div>}
                    <div className="ontario-checkboxes">
                        <div className="ontario-checkboxes__item">
                            <input title="agreementcheckbox" className="ontario-checkboxes__input" id="confirmation-agree" name="options" type="checkbox" value="agree"
                                checked={this.state.boxChecked} onChange={(e) => this.setState({boxChecked: !this.state.boxChecked})}></input>
                            <label className="ontario-checkboxes__label" htmlFor="checkbox-option-1">
                                I have read and agree to the Declaration and have read, agree and consent to the Collection and Use of Information as stated above.
                            </label>
                        </div>
                    </div>
                </fieldset>
            </div>
        );

        // buttons
        htmlString.push(
            <button className="ontario-button ontario-button--primary"
                onClick={() => {
                    if (!this.state.boxChecked) {
                        this.setState({showError: true});
                        window.scrollTo({top: 0, behavior: "smooth"})
                    } else{
                        CMAUtils.saveCMA(this.props.programContainer, "ApprovalPending").then(success=>{
                            if(success){
                                 this.props.callbackValueSaved();
                            }
                        });
                        this.props.callback(p);
                        this.setState({ showError: false });
                    }
                }}
                >Submit</button>
        );

        

        return htmlString;
    }
}